import { WINDOW_OPTIONS } from "../../../Components/common/DashboardWidgets/dashboardUtils";

export {
  WINDOW_OPTIONS,
  bucketLabel,
  formatDate,
} from "../../../Components/common/DashboardWidgets/dashboardUtils";

export const IOC_TYPES = [
  { id: "url", label: "URLs", short: "URL", color: "#36a2eb" },
  { id: "domain", label: "Domains", short: "Domain", color: "#a77bdb" },
  { id: "ip", label: "IP addresses", short: "IP", color: "#e69b55" },
  { id: "hash", label: "Hashes", short: "Hash", color: "#3fb6c9" },
];

export const DEFAULT_WINDOW = WINDOW_OPTIONS[0];

export const windowLabel = (id) =>
  (WINDOW_OPTIONS.find((option) => option.id === id) || DEFAULT_WINDOW).label;
